import React from 'react';
import { HeroSection } from '../components/stingfit/HeroSection';
import { MiniBundles } from '../components/stingfit/MiniBundles';
import { SocialProofSeal } from '../components/stingfit/SocialProofSeal';
import { ProblemEscalation } from '../components/stingfit/ProblemEscalation';
import { MechanismSection } from '../components/stingfit/MechanismSection';
import { BenefitsTimeline } from '../components/stingfit/BenefitsTimeline';
import { HowItWorks } from '../components/stingfit/HowItWorks';
import { ProductShowcase } from '../components/stingfit/ProductShowcase';
import { EbookSection } from '../components/stingfit/EbookSection';
import { ProblemReframe } from '../components/stingfit/ProblemReframe';
import { TestimonialGrid } from '../components/stingfit/TestimonialGrid';
import { OfferStack } from '../components/stingfit/OfferStack';
import { PricingBundles } from '../components/stingfit/PricingBundles';
import { FAQAccordion } from '../components/stingfit/FAQAccordion';
import { Button } from '../components/stingfit/ui/Button';
import { LiveActivityNotifications } from '../components/stingfit/LiveActivityNotifications';
export function StingFitLanding() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-362">
      {/* Sticky Header for Mobile/Desktop */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 py-4" data-id="element-363">
        <div className="container mx-auto px-4 flex justify-between items-center max-w-6xl" data-id="element-364">
          <div className="text-2xl font-black text-[#2D5016] tracking-tighter" data-id="element-365">
            STING<span className="text-[#D4AF37]" data-id="element-366">FIT</span>
          </div>
          <Button size="sm" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-367">
            Comprar Ahora
          </Button>
        </div>
      </header>

      <main data-id="element-368">
        <HeroSection data-id="element-369" />
        <MiniBundles data-id="element-370" />
        <SocialProofSeal data-id="element-371" />
        <ProblemEscalation data-id="element-372" />
        <MechanismSection data-id="element-373" />
        <BenefitsTimeline data-id="element-374" />
        <HowItWorks data-id="element-375" />
        <ProductShowcase data-id="element-376" />
        <EbookSection data-id="element-377" />
        <ProblemReframe data-id="element-378" />
        <TestimonialGrid data-id="element-379" />
        <OfferStack data-id="element-380" />
        <PricingBundles data-id="element-381" />
        <FAQAccordion data-id="element-382" />

        {/* Live Activity Notifications */}
        <LiveActivityNotifications data-id="element-383" />
      </main>

      <footer className="bg-[#2D5016] text-white py-12 border-t border-white/10" data-id="element-384">
        <div className="container mx-auto px-4 text-center max-w-6xl" data-id="element-385">
          <div className="text-2xl font-black tracking-tighter mb-6" data-id="element-386">
            STING<span className="text-[#D4AF37]" data-id="element-387">FIT</span>
          </div>
          <div className="flex justify-center gap-6 mb-8 text-sm text-green-100" data-id="element-388">
            <a href="#" className="hover:text-white" data-id="element-389">
              Términos
            </a>
            <a href="#" className="hover:text-white" data-id="element-390">
              Privacidad
            </a>
            <a href="#" className="hover:text-white" data-id="element-391">
              Contacto
            </a>
          </div>
          <p className="text-xs text-green-200/50 max-w-2xl mx-auto" data-id="element-392">
            © 2026 StingFit España. Todos los derechos reservados. Este sitio
            no es parte del sitio web de Facebook o Facebook Inc. Además, este
            sitio no está respaldado por Facebook de ninguna manera. FACEBOOK es
            una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}